"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "grosotto": {
    "b8d1ff75": [{
      "hkey": "30bcd2f2",
      "slug": "grosotto",
      "name": "Grosotto",
      "primary": true,
      "skipSearch": false
    }],
    "ca-modest": [{
      "hkey": "30bcd2f2",
      "slug": "grosotto",
      "name": "Grosotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f0a1bfce": [{
      "hkey": "30bcd2f2",
      "slug": "grosotto",
      "name": "Grosotto",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-san-martino": [{
      "hkey": "30bcd2f2",
      "slug": "grosotto",
      "name": "Grosotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d3cbea26": [{
      "hkey": "30bcd2f2",
      "slug": "grosotto",
      "name": "Grosotto",
      "primary": true,
      "skipSearch": false
    }],
    "piazza": [{
      "hkey": "30bcd2f2",
      "slug": "grosotto",
      "name": "Grosotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5b4d7ffc": [{
      "hkey": "30bcd2f2",
      "slug": "grosotto",
      "name": "Grosotto",
      "primary": true,
      "skipSearch": false
    }],
    "roncale": [{
      "hkey": "30bcd2f2",
      "slug": "grosotto",
      "name": "Grosotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c5b8224a": [{
      "hkey": "30bcd2f2",
      "slug": "grosotto",
      "name": "Grosotto",
      "primary": true,
      "skipSearch": false
    }],
    "san-sebastiano": [{
      "hkey": "30bcd2f2",
      "slug": "grosotto",
      "name": "Grosotto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;